import { useTranslation } from "react-i18next";

import { useAppNotification } from "@/modules/app-notification";
import { isApiError } from "@/services/api";

export function useApiErrorHandler() {
  const { t } = useTranslation();
  const { notify } = useAppNotification();

  const onError = (error: unknown) => {
    if (isApiError(error)) {
      const { message } = error.response.data;

      if (message) {
        notify.error({
          title: t("form:error:genericError"),
          description: message,
          duration: 0,
        });
        return;
      }
    }

    notify.error();
  };

  return { onError };
}
